import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'htmlToText' })

export class HtmlToTextPipe implements PipeTransform {

  constructor() {}

  transform(text: string) {
    if (text) {
      text = text.replace(new RegExp('<br>', 'g'), '');
      text = text.replace(new RegExp('&nbsp;', 'g'), '');

      text = text.replace(new RegExp('<div(.*?)>', 'g'), '');
      text = text.replace(new RegExp('</div>', 'g'), '');

      text = text.replace(new RegExp('<span(.*?)>', 'g'), '');
      text = text.replace(new RegExp('</span>', 'g'), '');

      text = text.replace(new RegExp('<p(.*?)>', 'g'), '');
      text = text.replace(new RegExp('</p>', 'g'), '');

      text = text.replace(new RegExp('<b(.*?)>', 'g'), '');
      text = text.replace(new RegExp('</b>', 'g'), '');

      text = text.replace(new RegExp('<i(.*?)>', 'g'), '');
      text = text.replace(new RegExp('</i>', 'g'), '');

      text = text.replace(new RegExp('<font(.*?)>', 'g'), '');
      text = text.replace(new RegExp('</font>', 'g'), '');

      text = text.replace(new RegExp('<o:p(.*?)>', 'g'), '');
      text = text.replace(new RegExp('</o:p>', 'g'), '');

      return text;
    }
    return null;
  }
}
